import { render, staticRenderFns } from "./BehaviourQuestion.vue?vue&type=template&id=f7fe4eaa&scoped=true&"
import script from "./BehaviourQuestion.vue?vue&type=script&lang=js&"
export * from "./BehaviourQuestion.vue?vue&type=script&lang=js&"
import style0 from "./BehaviourQuestion.vue?vue&type=style&index=0&id=f7fe4eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fe4eaa",
  null
  
)

export default component.exports